/**
 * Signing-template tags — one sanitizer shared by the template form
 * (client) and the signing-template routes (server), so the rules can
 * never drift between what the UI shows and what gets stored.
 *
 * Tags are plain strings stored on the template doc. Rules:
 *  - input must be an array; non-string entries are dropped;
 *  - each tag is trimmed; empties are dropped;
 *  - each tag is truncated to 32 characters;
 *  - duplicates are removed case-insensitively (first form wins);
 *  - at most 12 tags are kept.
 */

export const MAX_SIGNING_TEMPLATE_TAGS = 12;
export const MAX_SIGNING_TEMPLATE_TAG_LENGTH = 32;

export function sanitizeSigningTemplateTags(input: unknown): string[] {
  if (!Array.isArray(input)) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of input) {
    if (typeof raw !== 'string') continue;
    const trimmed = raw.trim();
    if (!trimmed) continue;
    const tag = trimmed.slice(0, MAX_SIGNING_TEMPLATE_TAG_LENGTH);
    const key = tag.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(tag);
    if (out.length >= MAX_SIGNING_TEMPLATE_TAGS) break;
  }
  return out;
}
